{
  "name": "@biwave/browser",
  "version": "0.5.2",
  "description": "Biwave Browser SDK — unhandled exception & rejection capture, browser/page context, auto breadcrumbs, and session replay",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/bitech-dev/biwave-js.git",
    "directory": "packages/browser"
  },
  "homepage": "https://github.com/bitech-dev/biwave-js/tree/main/packages/browser#readme",
  "bugs": {
    "url": "https://github.com/bitech-dev/biwave-js/issues"
  },
  "keywords": [
    "biwave",
    "browser",
    "sdk",
    "error-tracking",
    "breadcrumbs",
    "session-replay",
    "stream",
    "rrweb"
  ],
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.js"
    }
  },
  "files": [
    "dist",
    "README.md"
  ],
  "publishConfig": {
    "access": "public"
  },
  "sideEffects": false,
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "lint": "eslint .",
    "test": "vitest run",
    "typecheck": "tsc --noEmit",
    "clean": "rimraf dist"
  },
  "peerDependencies": {
    "@biwave/core": "workspace:^"
  },
  "dependencies": {
    "rrweb": "^2.1.0"
  },
  "devDependencies": {
    "@biwave/core": "workspace:^",
    "jsdom": "^29.1.1",
    "tsup": "^8.5.1",
    "typescript": "^5.9.3",
    "vitest": "^4.1.10"
  }
}
